import * as Yup from "yup";
const signInScheme = Yup.object().shape({
  email: Yup.string()
    .required("Bitte geben Sie eine E-Mail-Adresse an.")
    .email("Bitte geben Sie eine gültige E-Mail-Adresse ein."),
  password: Yup.string().required("Bitte geben Sie ein Passwort ein."),
});

export default signInScheme;
